module.exports = __webpack_public_path__ + "static/media/view3.b4268a6a.jpg";